import fetch from 'auth/FetchInterceptor'

const ArticleVersionsService = {}

// Article versions.
ArticleVersionsService.getArticleVersions = function (articleId) {
	return fetch({
		url: `/articles/single/${articleId}/versions`,
		method: 'get',
	})
}

export default ArticleVersionsService
